/* eslint-disable @typescript-eslint/no-unused-vars */
import { ExecutionStatus, StatusColor } from "./Types";

export const statusColorMap: { [key in ExecutionStatus]: StatusColor } = {
  draft: {
    color: "--neutral-dark",
    textColor: "--text-bright"
  },
  running: {
    color: "--cautionary",
    textColor: "--text"
  },
  completed: {
    color: "--positive",
    textColor: "--text-bright"
  },
  failed: {
    color: "--negative",
    textColor: "--text-bright"
  },
};

export const defaultStatusColor: StatusColor = {
  color: "--neutral",
  textColor: "--text"
};
